import AppConstants from '../../config/app.constants';

class OrderPackingController {

    /*@ngInject*/
    constructor($state, $q, $window, Modal, BranchService, DataCounter, $rootScope, LocationService, ShipmentService, User, UserBranchService,
        BranchFundingSourceService, $location, OrderPackingService, LedgerTransactionService, $translate, $scope, SetupService, DateUtil,
        Sound, HoldService, Navigation, AtmResidualDepositService, UserBranchFundingSourceService, RouteStopService, RouteService, UsersService, DenominationService, LocationDeliveryService, $timeout, CurrencyService) {
        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.Modal = Modal;
        this.BranchService = BranchService;
        this.LocationService = LocationService;
        this.ShipmentService = ShipmentService;
        this.User = User;
        this.UserBranchService = UserBranchService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.OrderPackingService = OrderPackingService;
        this.LedgerTransactionService = LedgerTransactionService;
        this.$location = $location;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Sound = Sound;
        this.HoldService = HoldService;
        this.Navigation = Navigation;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.RouteStopService = RouteStopService;
        this.RouteService = RouteService;
        this.UsersService = UsersService;
        this.DenominationService = DenominationService;
        this.CurrencyService = CurrencyService;
        this.currencySymbol = '$';
        this.currencyData = [];
        this.model = {
            loading: false,
            branchId: null,
            locationId: null,
            date: '',
            stats: 'pending',
            ledger: 'regular',
            loggedInUser: this.User.getUser().id,
            branch: this.User.getUser().branchId,
            selectedFundingSource: null,
            gettingLedgerDenomBalance: false,
            pendingFilterDate: null,            
        };
        this.denominations = {};
        this.denominationsArray = [];
        this.ledgerBalance = {
            totalAmount: 0,
            results: []
        };
        this.denoms = [];
        this.stats = {
            pending: 'pending',
            completed: 'completed',
            onHold: 'onHold'
        }

        this.accounts = {
            regular: 'regular',
            emergency: 'emergency'
        }

        this.ledgers = [
            {
                lable: "Regular",
                value: "regular"
            },
            {
                lable: "Emergency",
                value: "emergency"
            }
        ]
        this.orderSort = {
            id: false,
            total: false,
            route: false,
            toLocation: false
        }
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 1000,
            maxPages: 10
        };

        this.branches = [];
        this.locationLists = [];
        this.orderShipments = [];
        // this.groupedOrders = [];
        this.allOrderShipments = [];
        this.lastScannedLocation = "";
        this.lastScannedDate = "";
        this.allPackedShipments = [];
        this.allPackedChildShipments = [];
        this.packedShipmentBalances = [];
        this.packedShipments = [];
        this.packedChildShipments = [];
        this.reverseSort = true;
        this.sortColumn = "orderNo";
        this.currentPage = 1;
        this.itemsPerPage = 10;
        this.filteredItems = [];
        this.pageLimit = 10;
        this.page = 1;
        this.currentVaultDate = "";
        this.currentDenomBalance = "";
        this.routeList = [];
        this.remainingOrders = "";
        this.clearRouteId = false;
        this.pendingPackData = "";
        this.regularCount = 0;
        this.emergencyCount = 0;
        this.loadOnHoldShipments = true;
        this.shipmentsOnHoldList = [];
        this.$rootScope.$broadcast('routeChange', '/app/order-packing');
        this.userDetails = this.User.getUser();
        this.toggleSelect = true;
        this.completedShipmentDetails = [];
        this.LocationDeliveryService = LocationDeliveryService;
        this.deliveryToShipmentTypes = [];
    }

    // load BranchFundingSource data
    loadBranchFundingSource(searchKey) {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "sourceName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    mappingBranchFundingSource(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.sourceName,
                Value: location.id,
                locId: location.locationId,
                currencyId: location.currencyId,
                multiDenomPack: location.multiDenomPack,
                multiDenomBillLimit: location.multiDenomBillLimit,
                sourceName: location.sourceName
            }
        });
    }

    getBranchFundingSource(searchKey, offset) {
        // const loadLocationDatas = this.loadBranchFundingSource(searchKey);
        const defer = this.$q.defer();
        this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUser, this.model.branch)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingBranchFundingSource(data.results);
                    defer.resolve(this.locationLists)
                }
                else {
                    const locations = this.mappingBranchFundingSource(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
            })
        defer.promise.then(() => {
            this.pendingPackData = this.DataCounter.getPendingPackData();
            const redirectData = this.DataCounter.getData();
            
            if (this.pendingPackData && this.pendingPackData.isRedirected && this.locationLists.length) {
                this.model.locationId = _.find(this.locationLists, { locId: this.pendingPackData.locationId })
                this.model.date = this.DateUtil.convertToDate(this.pendingPackData.vaultDate);
                if (this.pendingPackData.isEC) this.model.ledger = 'emergency';
                else this.model.ledger = 'regular';
                this.getShipmentData(false);
                if (this.$translate.instant(this.pendingPackData.status) === 'Hold') {
                    this.model.stats = this.stats.onHold;
                    this.getPendingPackShipmentsOnHold();
                }
            }
            else if (redirectData && redirectData.isRedirected && redirectData.locationId && redirectData.orderNo && this.locationLists.length) {
                
                const fundingSource = _.find(this.locationLists, { Value: redirectData.fundingSourceId });
                if (fundingSource) {
                    this.model.locationId = fundingSource;
                }
                                
                this.model.searchText = redirectData.orderNo;
                
                this.getShipmentData(false);
            }
            else if (this.locationLists.length === 1) {
                this.model.locationId = this.locationLists[0];
                this.getShipmentData(false);
            }
            
            // Call BFS-dependent methods only after a BFS is selected
            if (this.model.locationId) {
                this.loadAllTabData(); // Load data for all tabs to ensure counts are displayed
            }
        }).finally(() => {
            // Only call getAvailableLedgerBalance if a BFS is selected
            if (this.model.locationId) {
            this.getAvailableLedgerBalance();
            }
            this.resetFilterData();
        })
    }

    $onInit() {
        this.model.branchId = this.User.getUser().branchId;
        const currencyPickACL = this.User.getACL('currency_pick_report');
        this.canViewCurrencyPick = Array.isArray(currencyPickACL) && currencyPickACL.indexOf('view') !== -1;

            this.$q.all([
                this.SetupService.get(this.model.branchId)
            ])
                .then((data) => {
                    this.model.date = this.DateUtil.convertToDate(data[0].currentVaultDate);
                    this.currentVaultDate = moment(this.model.date).format('YYYY-MM-DD');
                    this.minVaultDate = {
                        minDate: this.model.date
                    }
                    this.branchVaultDate = data[0].currentVaultDate;
                    this.model.printPackLabel = data[0].printPackLabel;
                    this.model.printPrePack = data[0].printPrePack;
                })
                .then(() => {
                    // Load currency data on init
                    this.loadCurrencyData();
                    this.getBranchFundingSource('', 0);
                    // Get all denominations on init for filtering when BFS changes
                    this.getAllDenoms();
                    // BFS-dependent calls moved to getBranchFundingSource method
                    // this.getPackedShipment();
                    // this.getPendingPackShipmentsOnHold();
                    // this.getcurBalanceByDenom();
                })
                .catch((err) => {
                    console.log(err);
                })
    }

    getAllDenoms() {
        // Get all denominations on init for filtering when BFS changes
        this.DenominationService.all('', 0, 1000).then((data) => {
            this.allDenominations = data.results.map(denom => ({
                ...denom,
                sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
            })); // Store all denominations
            this.filterDenominationsByBFS(); // Apply initial filtering if BFS is already selected
        }).catch((err) => {
            console.log(err);
        })
    }

    // Filter denominations based on selected BFS currency
    filterDenominationsByBFS() {
        if (!this.model.locationId || !this.allDenominations) {
            this.filteredDenoms = [];
            return;
        }
        
        const currencyId = this.model.locationId.currencyId;
        if (!currencyId) {
            console.error('No currency ID found for selected BFS');
            this.filteredDenoms = [];
            return;
        }
        
        // Filter denominations by currency on frontend
        this.filteredDenoms = this.allDenominations.filter(denom => denom.currencyId === currencyId);
        
        // Set currency symbol
        this.setCurrencySymbol();
    }

    setCurrencySymbol() {
        if (!this.model.locationId || !this.model.locationId.currencyId) {
            this.currencySymbol = '$';
            return;
        }

        const currencyId = this.model.locationId.currencyId;
        
        if (Array.isArray(this.currencyData) && this.currencyData.length > 0) {
            const currency = this.currencyData.find(c => c.id === currencyId);
            this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
        } else {
            // Load currency data if not already loaded
            this.loadCurrencyData().then(() => {
                const currency = this.currencyData.find(c => c.id === currencyId);
                this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
            });
        }
    }

    loadCurrencyData() {
        if (this.currencyData.length > 0) {
            return this.$q.resolve(this.currencyData);
        }

        return this.SetupService.get(this.model.branchId)
            .then((setup) => {
                const currencyIds = Array.isArray(setup.availableCurrencyIds) && setup.availableCurrencyIds.length > 0 
                    ? setup.availableCurrencyIds 
                    : [setup.currencyId];

                const currencySearchObj = {
                    queryJSON: {
                        rules: currencyIds.map(id => ({
                            field: "id",
                            condition: "=",
                            data: id
                        })),
                        operator: "OR"
                    }
                };

                return this.CurrencyService.all(currencySearchObj, 0, 100);
            })
            .then((data) => {
                this.currencyData = data.results || [];
                return this.currencyData;
            })
            .catch((err) => {
                console.log('Error loading currency data:', err);
                this.currencyData = [];
                return [];
            });
    }

    getCurrentDenomLedgerBalance(denominationId) {
        var item = this.ledgerBalance.results.find(result => result.denominationId === denominationId);
        return item ? item.balance : 0;
    }

    getDenomLedgerSymbol(denominationId) {
        const item = (this.ledgerBalance && this.ledgerBalance.results) ? this.ledgerBalance.results.find(r => r.denominationId === denominationId) : null;
        return (item && item.symbol) ? item.symbol : this.currencySymbol;
    }

    getPackedAmount(denominationId) { 
        const balance = this.packedShipmentBalances[denominationId] && this.packedShipmentBalances[denominationId].totalAmount;
        return balance || 0;
    }

    getPackedCashTotal() {
        if (!this.cashLedgerDenoms || !this.packedShipmentBalances) return 0;
        return this.cashLedgerDenoms.reduce((sum, d) => sum + this.getPackedAmount(d.id), 0);
    }

    getPackedCoinTotal() {
        if (!this.coinLedgerDenoms || !this.packedShipmentBalances) return 0;
        return this.coinLedgerDenoms.reduce((sum, d) => sum + this.getPackedAmount(d.id), 0);
    }

    getLedgerBalanceClass(denominationId) {
        var balance = this.getCurrentDenomLedgerBalance(denominationId);
        if (balance === 0) return 'bg-yellow';
        return this.denominations[denominationId] ? balance < this.denominations[denominationId].denomAmount ? 'bg-orange' : '' : '';
    };

    getTotalClass(){
        var allZero = this.ledgerBalance.totalAmount;
        return allZero !== 0 ? '' : 'bg-yellow';
    };
    focuseElementById(id) {
        setTimeout(() => {
            document.getElementById(id) ? document.getElementById(id).focus(): null;
        }, 300);
    }

    tabSelection(selectedValue) {
        this.model.stats = selectedValue;
        this.model.searchText = null;
        // this.model.route = null;
        this.model.orderType = null;
        this.model.selectedFundingSource = null;
        this.model.customerId = null;
        this.model.pendingFilterDate = null;
        this.getOrderPackCounts(this.allOrderShipments);
        this.getOrderPackedCounts(this.allPackedShipments);
        this.filterOnHoldShipments(this.shipmentsOnHoldList);
        this.loadLedgerData();
        if (this.model.locationId) this.getAvailableLedgerBalance();
        this.loadOrderPackingList();
        this.focuseElementById('searchtext');
    }

    getPackedShipment() {
        if (!this.model.locationId) {
            this.allPackedShipments = [];
            this.allPackedChildShipments = [];
            this.loadOrderPackingList();
            return;
        }
        
        const shipmentSearchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        field: 'packedFlag',
                        condition: '=',
                        data: true
                    },
                    {
                        field: 'pickupFlag',
                        condition: '=',
                        data: false
                    },
                    {
                        field: 'batchId',
                        condition: '=',
                        data: null
                    },
                    {
                        field: 'vaultDate',
                        condition: '>=',
                        data: moment(this.model.date).format('YYYY-MM-DD')
                    },
                    {
                        field: 'deleted',
                        condition: '=',
                        data: false
                    },
                    
                ],
                operator: "AND"
            },
            order: {
                fieldName: 'createdAt',
                keyword: 'DESC'
            }
        }
        const vaultDate = moment(this.model.date).format('YYYY-MM-DD');
        const bfsId = this.model.locationId ? this.model.locationId.Value : null;
        this.OrderPackingService.getPackedShipments(this.model.branchId, vaultDate, 0, 500, bfsId)
            .then((data) => {
                this.model.gettingPackedShipmentList = true;
                // this.pagination.total = data.total;
                // this.pagination.loading = false;
                this.allPackedShipments = data.results || [];

                const allShipments = this.allPackedShipments || [];

                const buildRowFromShipments = (shipments) => {
                    const first = shipments[0] || {};
                    const shipmentWithNullBagSeal = shipments.find(function (s) { return s.bagSeal === null; }) || first;
                    const denominations = shipments.map(function (order) {
                        if (order.denomination) {
                            return {
                                ...order.denomination,
                                amount: order.amount,
                                sortOrder: order.denomination.sortOrder || order.denomination.denominationSortOrder || 0
                            };
                        }
                        return null;
                    }).filter(Boolean);

                     const amount = shipments.reduce(function (sum, obj) {
                        if (obj.bagSeal === null && obj.packableOrderShipmentId === null) {
                            return sum;
                        }
                        return sum + obj.amount;
                    }, 0);

                    return {
                        orderNo: first.orderNo || 'no-order',
                        packableOrderShipmentId: (shipmentWithNullBagSeal && shipmentWithNullBagSeal.packableOrderShipmentId) ||
                                                 (first && first.packableOrderShipmentId) || null,
                        deliveredFlag: shipments.some(function (s) { return !!s.deliveredFlag; }),
                        denominations: denominations,
                        shipments: shipments,
                        ...first,
                        id: shipmentWithNullBagSeal ? shipmentWithNullBagSeal.id : (first.id || null),
                        trackingId: shipmentWithNullBagSeal ? shipmentWithNullBagSeal.trackingId : (first.trackingId || null),
                        amount: amount,
                        isSelected: false
                    };
                };

                const getNonPackableGroupKey = function (shipment) {
                    if (!shipment) return 'no-shipment';
                    if (shipment.bagSeal) return 'bag_' + shipment.bagSeal;
                    if (shipment.trackingId) return 'tracking_' + shipment.trackingId.split('-')[0];
                    return 'id_' + (shipment.id || 'unknown');
                };

                const ordersMap = _.groupBy(allShipments, function (shipment) {
                    return shipment.orderNo || 'no-order';
                });
                const groupedData = [];

                Object.keys(ordersMap).forEach(function (orderKey) {
                    const orderShipments = ordersMap[orderKey];
                    const hasPackable = orderShipments.some(function (s) {
                        return s.packableOrderShipmentId !== null && s.packableOrderShipmentId !== undefined;
                    });

                    if (!hasPackable) {
                        // ATM orders: keep multi-denom loads together, but show each single-denom load separately.
                        const isAtmOrder = orderShipments.some(function (s) {
                            const loc = s.toLocation || {};
                            return loc.locationType === 'ATM';
                        });

                        if (isAtmOrder) {
                            const byBagSeal = _.groupBy(orderShipments, function (s) {
                                return s.bagSeal || s.trackingId;
                            });
                            Object.keys(byBagSeal).forEach(function (bagKey) {
                                const bagGroup = byBagSeal[bagKey] || [];
                                groupedData.push(buildRowFromShipments(bagGroup));
                            });
                        } else {
                            // Non-ATM: keep existing behaviour (one row per order group)
                            const nonPackableGroups = _.groupBy(orderShipments, getNonPackableGroupKey);
                            Object.keys(nonPackableGroups).forEach(function (groupKey) {
                                groupedData.push(buildRowFromShipments(nonPackableGroups[groupKey]));
                            });
                        }
                    } else {
                        const bbShipments = [];
                        const nonBBShipments = [];

                        orderShipments.forEach(function (s) {
                            const denom = s.denomination || {};
                            const isCoin = denom && (denom.coinFlag === true || denom.coinFlag === 1);
                            const coinPackaging = denom ? (denom.coinPackaging || null) : null;
                            const isBB = isCoin && (coinPackaging === 'BOXED' || coinPackaging === 'BAGGED');

                            if (isBB) {
                                bbShipments.push(s);
                            } else {
                                nonBBShipments.push(s);
                            }
                        });

                        const byBag = _.groupBy(nonBBShipments, function (s) { return s.packableOrderShipmentId; });
                        const bagKeys = Object.keys(byBag);

                        let targetBagKey = null;
                        bagKeys.forEach(function (key) {
                            const bagShipments = byBag[key] || [];
                            if (!targetBagKey && bagShipments.length > 1) {
                                targetBagKey = key;
                            }
                        });
                        if (!targetBagKey && bagKeys.length > 0) {
                            targetBagKey = bagKeys[0];
                        }

                        bagKeys.forEach(function (bagKey) {
                            const bagShipments = byBag[bagKey] || [];
                            groupedData.push(buildRowFromShipments(bagShipments));
                        });
                        bbShipments.forEach(function (bb) {
                            groupedData.push(buildRowFromShipments([bb]));
                        });
                    }
                });

                this.allPackedShipments = groupedData;
                this.allPackedChildShipments = data.childShipments || [];   
                // this.packedShipmentBalances = data.packedShipmentBalances || [];
                this.getPackedDenomAmount(this.allPackedChildShipments);
                // this.loadLedgerData()
                this.loadOrderPackingList();
                this.getOrderPackedCounts(this.allPackedShipments);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.model.gettingPackedShipmentList = false;
            });
    }

    getPackedDenomAmount(shipments) {
        this.packedShipmentBalances = {};
        shipments.map((shipment) => {
            const denominationId = shipment.denomination ? shipment.denomination.id : null;
            const denominationName = shipment.denomination ? shipment.denomination.name : null;
    
            if (denominationId) {
                // Group by denomination and sum amounts
                if (!this.packedShipmentBalances[denominationId]) {
                    this.packedShipmentBalances[denominationId] = {
                        denominationName,
                        totalAmount: 0
                    };
                }
                this.packedShipmentBalances[denominationId].totalAmount += shipment.amount;
            }
        })
    }

    getOrderPackedCounts(array) {
        this.orderPackedRegularCount = 0;
        this.orderPackedEmergencyCount = 0;
        array.filter((item) => {
            this.orderPackedEmergencyCount += item.isEC;
            this.orderPackedRegularCount += !item.isEC;
        })
    }

    getOrderPackingList(clearRouteId) {
        if(!this.DataCounter.getData()){
            this.model.searchText = "";
        };
        return this.getShipmentData(clearRouteId);
    }

    getShipmentData(clearRouteId) {
        this.clearRouteId = clearRouteId;
        if (this.clearRouteId) { this.model.route = null }

        if (this.model.locationId && this.model.locationId.Value != this.lastScannedLocation || this.model.date != this.lastScannedDate) {
            this.page = 1;
        }

        if (!this.model.locationId) {
            this.allOrderShipments = [];
            this.orderShipments = [];
        }

        this.model.loading = true;
        if (this.model.date != null && this.model.branchId && this.model.locationId) {
            const date = moment(this.model.date).format('YYYY-MM-DD');
            this.OrderPackingService.orderPackingList(this.model.branchId,this.model.locationId.locId)
                .then((data) => {
                    if (data.length > 0) {
                        this.denominations = {};
                        this.denominationsArray = [];
                        this.lastScannedLocation = this.model.locationId.Value;
                        this.lastScannedDate = this.model.date;
                        this.total = data.length;
                        this.allOrderShipments = data;
                        const orderNoGrp = _.groupBy(this.allOrderShipments, (order) => `${order.orderNo}_${order.sourceType}`);
                        const keys = Object.keys(orderNoGrp);
                        let groupedData = [];
                        keys.forEach((key) => {
                            const groupedOrders = orderNoGrp[key];
                            const sourceType = key.split("_")[1];
                            const shouldUseMultiDenomModel = (this.model.locationId && this.model.locationId.multiDenomPack) || sourceType === 'PackableOrder';

                            if (shouldUseMultiDenomModel) {
                                groupedData.push({
                                    orderNo: key.split("_")[0], // Extract original orderNo
                                    sourceType, // Extract sourceType
                                    denominations: groupedOrders.map((order) => {
                                        return {
                                            ...order.denomination,
                                            amount: order.amount,
                                            coinPackaging: order.coinPackaging || (order.denomination ? order.denomination.coinPackaging : null),
                                            coinFlag: order.coinFlag || (order.denomination ? order.denomination.coinFlag : false),
                                            multiDenomPackable: order.multiDenomPackable || (order.denomination ? order.denomination.multiDenomPackable : false),
                                            sortOrder: order.denomination ? (order.denomination.sortOrder || order.denomination.denominationSortOrder || 0) : 0
                                        }
                                    }),
                                    shipments: groupedOrders.map((order) => ({
                                        ...order,
                                        coinPackaging: order.coinPackaging || (order.denomination ? order.denomination.coinPackaging : null),
                                        debitBulkCoinOnPack: order.debitBulkCoinOnPack
                                    })),
                                    ...groupedOrders[0],
                                    amount: groupedOrders.reduce((sum, obj) => sum + obj.amount, 0),
                                    isSelected: false,
                                });
                            } else {
                                groupedOrders.forEach((shipment) => {
                                    groupedData.push({
                                        ...shipment,
                                        denominations: [{
                                            ...shipment.denomination,
                                            amount: shipment.amount,
                                            coinPackaging: shipment.coinPackaging || (shipment.denomination ? shipment.denomination.coinPackaging : null),
                                            coinFlag: shipment.coinFlag || (shipment.denomination ? shipment.denomination.coinFlag : false),
                                            multiDenomPackable: shipment.multiDenomPackable || (shipment.denomination ? shipment.denomination.multiDenomPackable : false),
                                        sortOrder: shipment.denomination ? (shipment.denomination.sortOrder || shipment.denomination.denominationSortOrder || 0) : 0
                                        }],
                                        shipments: [{
                                            ...shipment,
                                            coinPackaging: shipment.coinPackaging || (shipment.denomination ? shipment.denomination.coinPackaging : null),
                                            debitBulkCoinOnPack: shipment.debitBulkCoinOnPack
                                        }],
                                        isSelected: false,
                                    });
                                });
                            }
                        });
                
                        this.allOrderShipments = groupedData;
                        this.getRoutes(this.allOrderShipments);
                    } else {
                        this.total = 0;
                        this.orderShipments = [];
                        this.allOrderShipments = [];
                        this.denominations = {};
                        this.denominationsArray = [];
                    }
                })
                .then(() => {
                    this.loadOrderPackingList();
                    if (this.model.stats === 'pending') {
                        this.focuseElementById('searchtext');
                    }
                    // this.getAvailableLedgerBalance();
                    // if (this.model.ledger) {
                    //     this.getcurBalanceByDenom();
                    // }
                })
                .then(() => {
                    if (this.pendingPackData) {
                        this.pendingPackData.isRedirected = false;
                    }
                })
                .catch((err) => {
                    this.Modal.errorModal('error.' + err.data.message)
                })
                .finally(() => {
                    this.model.loading = false;
                });
        }
    }

    getOrderType(obj) {
        if (obj && obj.orderType) {
            const key = 'shipment.order_type_' + obj.orderType;
            const translated = this.$translate.instant(key);
            return translated !== key ? translated : obj.orderType;
        }
        if (obj && obj.shiptypeId) return obj.shiptypeId;
        return '';
    }

    // get balance by denomination from ledger
    orderPack(orderShipment) {
        if (this.isLoading) return;
        this.isLoading = true;
    
        const defer = this.$q.defer(); 
        let locationDeliveryPromise = Promise.resolve();
    
        // Only make the LocationDeliveryService call if the locationType is ATM and stopProcess is L and not emergency load
        if (orderShipment.toLocation.stopProcess === 'L' && orderShipment.toLocation.locationType === 'ATM' && orderShipment.isEC === 0 || orderShipment.sourceType==='PackableOrder') {
            locationDeliveryPromise = this.LocationDeliveryService.getLocationDeliveryDetails(orderShipment.toLocation.id).then(results => {
                this.deliveryToShipmentTypes = results.filter(shipType => shipType.pickupRequired === true);
            });
        } else {
            this.deliveryToShipmentTypes = [] 
        }
        const requestedDenomIds = orderShipment.denominations.map((denom) => denom.id);
        // Assuming orderShipment.denominations is now an array
        const denominationPromise = this.OrderPackingService.getcurBalanceByDenom(
                this.model.branchId,
                this.model.ledger,
                requestedDenomIds,
                this.model.locationId.Value
            );
    
        // Use Promise.all to ensure both promises complete before proceeding
        Promise.all([locationDeliveryPromise, denominationPromise])
            .then(([_, data]) => {
                const responseDenomIds = data.map((item) => item.denominationId);
                const missingDenomIds = requestedDenomIds.filter((id) => !responseDenomIds.includes(id));
                
                if (missingDenomIds.length > 0) {
                    this.isLoading = false;
                    this.Sound.PlayErrorBeep("#scanner_beep");
                    this.message = this.$translate.instant('orderPacking.insufficient_balance', {
                        Denomination: missingDenomIds.join(', '),
                    });
                    return this.Modal.errorModal(this.message);
                }
                
                let results = orderShipment.denominations.map((denom) => {
                    const balanceData = data.find(denomBalance => denomBalance.denominationId === denom.id);
                    if (!balanceData) {
                        return {
                            denomination: denom,
                            balance: { balance: 0, denominationId: denom.id, currencyId: null },
                            isDenomAvailable: false
                        };
                    }
                    return {
                        denomination: denom,
                        balance: balanceData,
                        isDenomAvailable: true
                    };
                });
    
                let validDenominations = [];
                let invalidDenominations = [];
                let availableAmountCanBePacked = this.model.locationId.multiDenomBillLimit;
                let multiDenomBillLimitExceed = false;
    
                // Get debitBulkCoinOnPack flag from first shipment
                const firstShipment = orderShipment.shipments && orderShipment.shipments[0];
                const debitBulkCoinOnPack = firstShipment && (firstShipment.debitBulkCoinOnPack === 1 || firstShipment.debitBulkCoinOnPack === true);

                results.forEach((result) => {
                    const { denomination, balance, isDenomAvailable } = result;
                    let amountInCents = Math.round(denomination.amount * 100);
                    let faceValueInCents = Math.round(denomination.faceValue * 100);
                    let isValid = amountInCents % faceValueInCents === 0;
                    const isPTZeroAllowed = ["T", "P"].includes(orderShipment.orderType) && Number(denomination.amount) === 0;
                    if (!isDenomAvailable) {
                        invalidDenominations.push(denomination);
                        return;
                    }

                    const inAdequateCash = balance.balance < denomination.amount;

                    // Check if this is a BB coin (BOXED/BAGGED) that should be debited independently
                    const coinPackaging = denomination.coinPackaging;
                    const coinFlag = denomination.coinFlag === 1 || denomination.coinFlag === true;
                    const isBB = debitBulkCoinOnPack && 
                                 coinPackaging && 
                                 (coinPackaging === 'BOXED' || coinPackaging === 'BAGGED') &&
                                 coinFlag;

                    if (isPTZeroAllowed) {
                        validDenominations.push(denomination);
                        return;
                    }

                    if (
                        (orderShipment.orderType && !["T", "P", "S"].includes(orderShipment.orderType)) ||
                        (denomination.amount > 0)
                    ) {
                        // Check balance for all denominations, including BB coins
                        // Even if BB coins are debited independently, we should validate balance upfront
                        if (isBB) {
                            // BB coins debited independently: still chleck balance, but they're always valid if balance is sufficient
                            if (inAdequateCash) {
                                invalidDenominations.push(denomination);
                            } else {
                                validDenominations.push(denomination);
                            }
                        } else if (
                            isValid &&
                            denomination.amount >= denomination.faceValue &&
                            !inAdequateCash
                        ) {
                            const shouldApplyMultiDenomBillLimit = this.model.locationId.multiDenomPack && orderShipment.sourceType !== 'PackableOrder';
                            if (shouldApplyMultiDenomBillLimit) {
                                if (denomination.amount <= availableAmountCanBePacked) {
                                    validDenominations.push(denomination);
                                    availableAmountCanBePacked -= denomination.amount;
                                } else {
                                    invalidDenominations.push(denomination);
                                    multiDenomBillLimitExceed = true;
                                }
                            } else {
                                validDenominations.push(denomination);
                            }
                        } else {
                            invalidDenominations.push(denomination);
                        }
                    }
                });
                
                orderShipment.validDenominations = validDenominations;
                orderShipment.invalidDenominations = invalidDenominations;
    
                if (invalidDenominations.length > 0) {
                    this.Sound.PlayErrorBeep("#scanner_beep");
                    this.message = this.$translate.instant('orderPacking.invalidDenominations') || null;
    
                    if (multiDenomBillLimitExceed) {
                        this.message = this.$translate.instant('orderPacking.multi_denom_bill_limit_exceed');
                    }
                    else if (invalidDenominations.some(denom => denom.amount < denom.faceValue)) {
                        this.message = this.$translate.instant('orderPacking.invalidAmount');
                    } else {
                        this.message = this.$translate.instant('orderPacking.insufficient_balance', {
                            Denomination: invalidDenominations.map(d => d.id).join(', '),
                        });
                    }
    
                    this.isLoading = false;
                    return this.Modal.errorModal(this.message);
                } else {
                    return this.callOrderPack(orderShipment);
                }
            })
            .catch((err) => {
                console.log(err);
                this.isLoading = false;
            });
    }
    
    
    

    callOrderPack(orderShipment) {
        let selectedOrder = null
        const isMultiDenomModel = (this.model.locationId && this.model.locationId.multiDenomPack) || orderShipment.sourceType === 'PackableOrder';
        if (isMultiDenomModel) {
            selectedOrder = this.orderShipments.find((order) => order.orderNo === orderShipment.orderNo && order.sourceType === orderShipment.sourceType)
            // include only shipments whose value
            selectedOrder.shipments = orderShipment.shipments.filter(shipment => 
                orderShipment.validDenominations.some(denom => denom.id === shipment.denominationId)
            );
            
        } else {
            selectedOrder = this.orderShipments.find(order => order.trackingId === orderShipment.trackingId) 
        }
        // get selected shipments
        this.Modal.orderPack(orderShipment, this.model.branchId, this.model.locationId.Value, this.model.ledger, selectedOrder, this.deliveryToShipmentTypes, ({ modal, data, status }) => {
            if (status) {
                // Refresh all tab data after successful packing
                this.loadAllTabData();
                this.getAvailableLedgerBalance();
                modal.close();
                this.isLoading = false;
            }
        }, ({ modal }) => {
            this.isLoading = false;
            modal.close();
        }, this.currencySymbol);
    }

    paginator() {
        this.begin = ((this.page - 1) * this.itemsPerPage);
        this.end = this.begin + this.itemsPerPage;
        // this.filteredItems = this.orderShipments.slice(this.begin, this.end);
    }

    sortCollection(type, column) {
        if (this.sortColumn !== column) {
            this.reverseSort = false;
        } else {
            this.reverseSort = !this.reverseSort;
        }
        this.sortColumn = column;
    }
    
    getSortExpression() {
        return this.sortColumn === 'orderNo' ? (item => Number(item.orderNo) || 0) : this.sortColumn;
    }
    // sort data table by column
    // SortData(column) {
    //     console.log(this.orderShipments);
    //     this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;

    //     this.orderShipments = this.sort(this.orderShipments, column, this.reverseSort)
    //     console.log(this.orderShipments);
    // }

    sort(array, column, reverse) {
        let finalArray = array.sort((a, b) => {
            if (typeof a[column] == 'string') {
                var val = (a[column] + '').localeCompare(b[column] + '');
            }

            if (a[column] > b[column]) return 1;
            if (a[column] < b[column]) return -1;
            return 0;
        });

        if (reverse) finalArray = finalArray.reverse();
        return finalArray;
    }

    // get class based on sort data
    getSortClass(column) {
        if (this.sortColumn == column) {
            return this.reverseSort ? 'arrow-down' : 'arrow-up'
        }
        return '';
    }

    calculateDenomAmount(shipments) {
    this.totalDenomAmount = 0;
    this.denominations = {};

    shipments.forEach(order => {
        if (order.denominations && Array.isArray(order.denominations)) {
            order.denominations.forEach(denom => {
                const denomId = denom.id;
                
                if (!this.denominations[denomId]) {
                    this.denominations[denomId] = {
                        denominationId: denomId,
                        denomAmount: 0,
                        name: denom.name,
                        faceValue: denom.faceValue,
                        icon: `assets/images/${denomId}.png`,
                        symbol: denom.symbol || this.currencySymbol,
                        sortOrder: denom.sortOrder || denom.denominationSortOrder || 0
                    };
                }
                
                this.denominations[denomId].denomAmount += denom.amount;
                this.totalDenomAmount += denom.amount;
            });
        }
    });
    this.denominationsArray = Object.values(this.denominations);
    }

    getRoutes(data) {
        const grouped = _.groupBy(data, 'routeId');
        const routeList = Object.keys(grouped);
        this.routeList = routeList;
    }

    // filter order packing list based on selected route and account
    filterOrderPacking(data) {
        let filterOrderPackList;
        // let list = data.filter((shipment => shipment.bagSeal === null)) || []; // to get only parent shipments
        let list = data || []; 
        if (this.model.customerId) {
            list = list.filter(item => item.customerId == this.model.customerId);
        }
        if (this.model.pendingFilterDate) {
            const selectedDate = moment.parseZone(this.model.pendingFilterDate).format('YYYY-MM-DD');
            list = list.filter(item => {
                const itemDate = item.vaultDate || item.deliveryDate;
                return itemDate && moment(itemDate).utc().format('YYYY-MM-DD') === selectedDate;
            });
        }

        list = list.map(item => {
            if (!item.orderType && item.shiptypeId) {
                item.orderType = item.shiptypeId;
            }
            return item;
        });
        if (this.pendingPackData && this.pendingPackData.isRedirected) {
            if (this.routeList.includes(this.pendingPackData.routeId)) {
                this.model.route = this.pendingPackData.routeId;
            }
            if (this.pendingPackData.orderNo) this.model.searchText = this.pendingPackData.orderNo;
        }

        if (!this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if ((data.fundingSourceId == this.model.selectedFundingSource) && !data.isEC) {
                    return data;
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.orderType == this.model.orderType) && !data.isEC) {
                    return data;
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.orderType == this.model.orderType) && data.isEC) {
                    return data;
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'regular' && this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.routeId == this.model.route && data.orderType == this.model.orderType) && !data.isEC) {
                    return data;
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.routeId == this.model.route && data.orderType == this.model.orderType) && data.isEC) {
                    return data;
                }
            })
        }else if(this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.orderType){
            filterOrderPackList = list.filter((data) => {
                if((data.orderType == this.model.orderType && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) && !data.isEC){
                    return data;
                }
            })
        }else if(this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.orderType){
            filterOrderPackList = list.filter((data) => {
                if((data.orderType == this.model.orderType && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) && data.isEC){
                    return data;
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'regular' && this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.routeId == this.model.route && data.orderType == this.model.orderType 
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) && !data.isEC) {
                    return data;
                }
            })
        } 
        else if (this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.orderType) {
            filterOrderPackList = list.filter((data) => {
                if ((data.routeId == this.model.route && data.orderType == this.model.orderType 
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) && data.isEC) {
                    return data;
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if ((data.fundingSourceId == this.model.selectedFundingSource) && data.isEC) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && !this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.isEC
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'emergency' && !this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.isEC && data.fundingSourceId == this.model.selectedFundingSource
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (!this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && data.isEC && data.fundingSourceId == this.model.selectedFundingSource
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'emergency' && this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && data.isEC && data.fundingSourceId == this.model.selectedFundingSource
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'regular' && !this.model.route && !this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (!data.isEC
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.ledger == 'regular' && !this.model.route && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (!data.isEC && data.fundingSourceId == this.model.selectedFundingSource
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.route && this.model.ledger == 'regular' && !this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && !data.isEC
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.route && this.model.ledger == 'regular' && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && !data.isEC && data.fundingSourceId == this.model.selectedFundingSource
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (!this.model.searchText && this.model.route && this.model.ledger == 'regular' && this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && !data.isEC && data.fundingSourceId == this.model.selectedFundingSource) {
                    return data
                }
            })
        }
        else if (this.model.searchText && this.model.route && this.model.ledger == 'emergency' && !this.model.selectedFundingSource) {
            filterOrderPackList = list.filter((data) => {
                if (data.routeId === this.model.route && data.isEC
                    && (data.orderNo.indexOf(this.model.searchText) >= 0 || data.toLocationId.indexOf(this.model.searchText) >= 0)) {
                    return data
                }
            })
        }
        else if (this.model.route && this.model.ledger == 'emergency') {
            filterOrderPackList = list.filter((data) => {
                return data.routeId === this.model.route && data.isEC
            })
        }
        else if (this.model.route && this.model.ledger == 'regular') {
            filterOrderPackList = list.filter((data) => {
                return data.routeId === this.model.route && !data.isEC
            })
        }
        else if (this.model.ledger && this.model.ledger == 'emergency') {
            filterOrderPackList = list.filter((data) => {
                return data.isEC
            })
        }
        else if (this.model.ledger && this.model.ledger == 'regular') {
            filterOrderPackList = list.filter((data) => {
                return !data.isEC
            })
        }
        else {
            filterOrderPackList = list;
        }
        this.calculateDenomAmount(filterOrderPackList);

        if(this.model.stats === 'pending') {
            this.getOrderPackCounts(filterOrderPackList);
        } else if (this.model.stats === 'completed') {
            this.getOrderPackedCounts(filterOrderPackList);
        } else if (this.model.stats === 'onHold') {
            this.filterOnHoldShipments(filterOrderPackList);    
        }


        return filterOrderPackList.map(item => {
            if (item.orderType && item.orderType === item.shiptypeId) {
                item.orderType = null
            }
            return item;
        });;
    }

    loadOrderPackingList() {
        if (this.allOrderShipments.length && this.model.stats === 'pending') {
            this.orderShipments = this.filterOrderPacking(this.allOrderShipments);
            this.reverseSort = false;
            this.getOrderPackCounts(this.orderShipments);
            this.findUniqueOrderNo(this.orderShipments);
            this.sortCollection('P', 'vaultDate');
            this.getSortClass('vaultDate');
            this.getRoutes(this.allOrderShipments);
            this.getOrderTypeList(this.allOrderShipments);
            this.getFundingSource(this.allOrderShipments);
            this.getCustomerList(this.allOrderShipments);
        }
    
        if (this.allPackedShipments.length && this.model.stats === 'completed') {
            this.packedChildShipments = this.filterOrderPacking(this.allPackedChildShipments);
            this.packedShipments = this.filterOrderPacking(this.allPackedShipments);
            this.reverseSort = true;
            this.sortCollection('P', 'vaultDate');
            this.getSortClass('vaultDate');
            this.getPackedDenomAmount(this.packedChildShipments);
            this.getRoutes(this.allPackedShipments);
            this.getOrderTypeList(this.allPackedShipments);
            this.getFundingSource(this.allPackedShipments);
            this.getCustomerList(this.allPackedShipments);
        } else {
            this.packedShipments = [];
        }
    
        if (this.shipmentsOnHoldList.length && this.model.stats === 'onHold') {
            const orderNoGrp = _.groupBy(this.shipmentsOnHoldList, (s) => s.packableOrderShipmentId ? `${s.orderNo}_${s.packableOrderShipmentId}` : s.trackingId);
            const keys = Object.keys(orderNoGrp);
            let groupedHold = keys.map(key => {
                const group = orderNoGrp[key];
                const parent = group[0];
                const denominations = group.map(g => {
                    if (g.denominationId) {
                        return {
                            id: g.denominationId,
                            name: g.denominationName,
                            faceValue: g.denominationFaceValue,
                            amount: g.amount,
                            symbol: g.symbol,
                            sortOrder: g.sortOrder || g.denominationSortOrder || 0
                        }
                    }
                }).filter(Boolean);

                return {
                    ...parent,
                    orderNo: parent.packableOrderShipmentId ? key.split("_")[0] : parent.orderNo,
                    packableOrderShipmentId: parent.packableOrderShipmentId ? key.split("_")[1] : parent.packableOrderShipmentId,
                    // ensure single-denom (non-COD) rows still have denominations array
                    denominations: denominations.length ? denominations : (parent.denominationId ? [{
                        id: parent.denominationId,
                        name: parent.denominationName,
                        faceValue: parent.denominationFaceValue,
                        amount: parent.amount,
                        symbol: parent.symbol,
                        sortOrder: parent.sortOrder || parent.denominationSortOrder || 0
                    }] : []),
                    shipments: group,
                    amount: group.reduce((sum, x) => sum + (x.amount || 0), 0)
                }
            });
            this.onHoldShipmentList = this.filterOrderPacking(groupedHold);
            this.reverseSort = true;
            this.sortCollection('H', 'trackingId');
            this.getSortClass('trackingId');
            this.getRoutes(groupedHold);
            this.getOrderTypeList(groupedHold);
            this.getFundingSource(groupedHold);
            this.getCustomerList(groupedHold);
        } else {
            this.onHoldShipmentList = [];
        }
    
        // if (this.orderShipments.length && this.model.stats === 'pending') {
        //     return this.focuseElementById('pack-btn');
        // }
    }

    findUniqueOrderNo() {
        const orderNoGrp = _.groupBy(this.orderShipments, (shipment) => `${shipment.orderNo}_${shipment.sourceType}`);
        const keys = Object.keys(orderNoGrp);
        this.remainingOrders = keys.length;
    }

    pageChange() {
        if (this.model.locationId) {
        this.getPackedShipment();
        }
    }

    // orderPack(orderShipment, index) {
    //     this.disablePack(index);
    //     this.Modal.orderPack(orderShipment, this.model.branchId, this.model.locationId.Value, this.model.ledger, ({ modal, data, status }) => {
    //         if (status) {
    //             this.getShipmentData();
    //             this.getPackedShipment();
    //         }
    //         modal.close();
    //     })
    // }

    loadLedgerData() {
        if (this.allOrderShipments.length && this.model.stats === 'pending') {
            this.orderShipments = this.filterData(this.allOrderShipments);
            this.reverseSort = true;
            this.sortCollection('P', 'orderNo');
            this.getSortClass('orderNo')
        }

        if (this.allPackedShipments.length && this.model.stats === 'completed') {
            this.packedShipments = this.filterData(this.allPackedShipments);
            this.reverseSort = true;
            this.sortCollection('C', 'id');
            this.getSortClass('id')
        }

        // if (this.model.ledger) {
        //     this.getcurBalanceByDenom();
        // }
    }

    filterData(dataArray) {
        let filteredData;
        if (this.model.ledger && this.model.ledger == 'emergency') {
            filteredData = dataArray.filter((item) => {
                return item.isEC
            })
        } else if (this.model.ledger) {
            filteredData = dataArray.filter((item) => {
                return !item.isEC
            })
        } else {
            filteredData = dataArray;
        }
        this.calculateDenomAmount(filteredData)
        return filteredData;
    }

    // orderHold(orderShipment) {
    //     this.Modal.orderPackHold(orderShipment, ({ modal }) => {
    //     })
    // }

    orderPackingCancel(orderShipment) {
        this.isCancel = true;
        const shipmentId = orderShipment.shipmentId;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('orderPacking.confirm_delete_message') + ` <strong>${shipmentId}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                this.OrderPackingService.orderPackingCancel(shipmentId, orderShipment.branchId)
                    .then((data) => {
                        modal.close();
                        this.getShipmentData();
                    })
                    .catch((err) => {
                        this.Modal.errorModal('error.' + err.data.message)
                    })
            }),
            type: 'danger'
        })
        setTimeout(() => {
            this.isCancel = false;
        }, 1000)
    }

    getOrderPackCounts(array) {
        this.emergencyCount = 0;
        this.regularCount = 0;
        array.filter((item) => {
                this.emergencyCount += item.isEC;
                this.regularCount += !item.isEC;
        })
    }

    redirectToOrderTab(data) {
        let isInProcess = data.packedFlag && !data.finishedAt;
        let isPending = !data.packedFlag;
        let isCounted = data.finishedAt;
        let fundingSourceId = data.fundingSourceId ? data.fundingSourceId : this.model.locationId.Value;
        this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, isCounted, isInProcess, isPending, null, fundingSourceId);
    }

    softDeleteShipment(shipment) {
        this.Modal.deletedReason(shipment, ({ supervisorId, reason, modal }) => { if (shipment.sourceType === "PackableOrder") {
            this.OrderPackingService.softDeleteOrder(shipment.orderNo,supervisorId,shipment.branchId)
                .then((res) => {
                    modal.close();
                    // Refresh all tab data after successful soft delete operation
                    this.loadAllTabData();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message)
                    }
                })
        } else {
          this.ShipmentService.softDeleteShipment(
            shipment.shipmentId,
            shipment.branchId,
            reason,
            supervisorId
          )
            .then((res) => {
              modal.close();
              // Refresh all tab data after successful soft delete operation
              this.loadAllTabData();
            })
            .catch((err) => {
              modal.close();
              if (err && err.data && err.data.message) {
                this.Modal.errorModal(err.data.message);
              }
            });
        }
        }, ({ modal }) => {
            modal.close();
        });
    }

    goToServiceHistory(data) {
        const obj = {
            locationId: data.toLocation.id || data.toLocationId,
            vaultDate: null,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    formatAddress(data) {
        this.locationAddress = '';
        if (data.toLocation.address) {
            this.locationAddress = this.locationAddress.concat(data.toLocation.address, ', ');
        }
        if (data.toLocation.city) {
            this.locationAddress = this.locationAddress.concat(data.toLocation.city, ', ');
        }
        if (data.toLocation.state) {
            this.locationAddress = this.locationAddress.concat(data.toLocation.state, ', ');
        }
        if (data.toLocation.zip) {
            this.locationAddress = this.locationAddress.concat(data.toLocation.zip);
        }
        return this.locationAddress;
    }

    convertToCrv(shipment,event) {
        if (this.loading) return;
        this.loading = true;

        
    if (event && event.target) {
        event.target.blur();
    }

        const allowSupervisorScan = this.userDetails.hasOwnProperty('supervisor') ? !this.userDetails.supervisor : false;

        this.Modal.convertToCrv(shipment, allowSupervisorScan, true, ({ supervisor, trackingIdResidual, modal }) => {
            if (trackingIdResidual) {
                // For CRV we need the load tracking ID:
                // 1) Prefer explicit loadTrackingId from the completed row (when present)
                // 2) Otherwise fall back to bagSeal (parent load)
                // 3) Finally, fall back to this row's trackingId (ATM single‑denom with no parent)
                const trackingLoad = shipment.loadTrackingId || shipment.bagSeal || shipment.trackingId;

                // Also send all single‑denom trackingIds that belong to this
                // packed row (helpful for ATM and multi‑denom orders).
                const singleDenomTrackingIds =
                    (shipment.shipments || [])
                        .filter(s => s.denominationId || (s.denomination && s.denomination.id))
                        .map(s => s.trackingId);

                this.HoldService.convertToCRV(
                    this.model.branchId,
                    trackingLoad,
                    trackingIdResidual,
                    allowSupervisorScan ? supervisor : this.model.loggedInUser,
                    singleDenomTrackingIds
                )
                    .then((data) => {
                        modal.close();
                        this.loading = false;
                        // Refresh all tab data after successful CRV conversion
                        this.loadAllTabData();
                    })
                    .catch((err) => {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            this.loading = false;
                            this.Modal.errorModal('error.' + err.data.message)
                        }
                    })
            }
            else {
                if (modal) modal.close();
                this.loading = false;
            }
        }, ({ modal }) => {
            if (modal) modal.close();
            this.loading = false;
        })
    }

    convertToCrvPackableOrder(shipment, event) {
    if (this.isLoading) return;
    this.isLoading = true;

    if (event && event.target) {
        event.target.blur();
    }

    this.Modal.confirm({
      header: 'Confirm CRV Conversion', 
      message: 'Are you sure you want to convert this Shipment to CRV?', 
      callback: ({ modal, $scope }) => {
        modal.close();
        this.UsersService.checkSupervisor(this.model.loggedInUser)
          .then((userInfo) => {
            this.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, ({ modal: supModal, supId }) => {
              supModal.close();
              this.HoldService.convertToCrvPackableOrder(this.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId)
                .then((data) => {
                  this.isLoading = false;
                  // Refresh all tab data after successful packable order packing
                  this.loadAllTabData();
                })
                .catch((err) => {
                  if (err && err.data && err.data.message) {
                    this.isLoading = false;
                    this.Modal.errorModal('error.' + err.data.message);
                  }
                });
            }, ({ modal: supModal }) => {
              supModal.close();
              this.isLoading = false;
            });
          })
          .catch((err) => {
            this.Modal.errorModal(err.data.message);
            this.isLoading = false;
          });
      },
      negative: ({ modal, $scope }) => {
        modal.close();
        this.isLoading = false;
      }
    }, ({ modal }) => {
        if (modal) modal.close();
        this.isLoading = false;
    });
  }

    lastOrderDetails(shipment) {
        this.Modal.lastOrderDetails(shipment, this.model.locationId.Value, ({ modal }) => {
            modal.close();
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    orderPackingUndo(shipment) {
        if (this.loading) return;
        this.loading = true;

        this.Modal.undoPackedOrder(shipment, ({ modal, supervisorId, deleteOrder, deletedReason, $scope }) => {
            this.ShipmentService.orderPackingUndo(this.model.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder)
                .then(() => {
                    modal.close();
                    this.loading = false;
                    // Refresh all tab data after successful undo operation
                    this.loadAllTabData();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.loading = false;
                        this.Modal.errorModal('error.' + err.data.message);
                    }
                })
            // .finally(() => {
            //     $scope.model.loading = false;
            // })
        }, ({ modal }) => {
            if (modal) modal.close();
            this.loading = false;
            // $scope.model.loading = false;
        })
    }

    loadData() {
        if (this.model.locationId) {
        this.getPackedShipment();
            this.getOrderPackingList(false);
        }
    }

    getAvailableLedgerBalance() {
        this.model.ledgerShortFall = 0;
        this.cashTotalBalance = 0;
        this.coinTotalBalance = 0;
        this.cashLedgerDenoms = [];
        this.coinLedgerDenoms = [];
        this.model.gettingLedgerDenomBalance = true;
        
        // Pass BFS ID if selected, otherwise pass null for no filtering
        const bfsId = this.model.locationId ? this.model.locationId.Value : null;
        
        this.AtmResidualDepositService.ledgerDenomBalanceFundingSource(this.model.branchId, this.model.ledger, bfsId)
                .then((data) => {
                    this.ledgerBalance = data;
                    let availableLedgerBalance = data.totalAmount;
                    let cashRemainingToBePack = this.totalDenomAmount;
                    this.model.ledgerShortFall = availableLedgerBalance - cashRemainingToBePack;
                    let filteredDenoms = this.allDenominations.filter((denom) => 
                        data.results.some((item) => item.denominationId === denom.id)
                    );
                    this.filteredDenoms = filteredDenoms;
                    this.cashLedgerDenoms = filteredDenoms.filter(d => d.coinFlag === false);
                    this.coinLedgerDenoms = filteredDenoms.filter(d => d.coinFlag === true);
                    this.cashTotalBalance = this.cashLedgerDenoms.reduce((sum, d) => sum + this.getCurrentDenomLedgerBalance(d.id), 0);
                    this.coinTotalBalance = this.coinLedgerDenoms.reduce((sum, d) => sum + this.getCurrentDenomLedgerBalance(d.id), 0);
                    // this.totalLedgerBalance = this.cashTotalBalance + this.coinTotalBalance;
                    if (this.orderShipments.length) {
                        return this.focuseElementById('pack-btn');
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal('error.' + err.data.message)
                    }
                })
                .finally(() => {
                    this.model.gettingLedgerDenomBalance = false;
                })
        }

    // Load all tab data when BFS selection changes
    loadAllTabData() {
        // Load data for all tabs to ensure counts are displayed
        this.getPackedShipment(); // Completed tab
        this.getPendingPackShipmentsOnHold(); // On Hold tab
        this.getOrderPackingList(false); // Pending tab
        this.filterDenominationsByBFS(); // Filter denominations
        
        // After all data is loaded, calculate counts for all tabs
        // Use timeout to ensure all async operations complete
        this.$timeout(() => {
            this.calculateAllTabCounts();
            if (this.model.stats === 'pending') {
                this.focuseElementById('searchtext');
            }
        }, 500); // Longer delay to ensure all data is loaded
    }

    // Calculate counts for all tabs regardless of current active tab
    calculateAllTabCounts() {
        // Calculate counts for Pending tab
        if (this.allOrderShipments && this.allOrderShipments.length > 0 && this.orderShipments.length > 0) {
            this.getOrderPackCounts(this.orderShipments);
        }
        
        // Calculate counts for Completed tab
        if (this.allPackedShipments && this.allPackedShipments.length > 0 && this.packedShipments.length > 0) {
            this.getOrderPackedCounts(this.packedShipments);
        }
        
        // Calculate counts for On Hold tab
        if (this.shipmentsOnHoldList && this.shipmentsOnHoldList.length > 0) {
            this.filterOnHoldShipments(this.shipmentsOnHoldList);
        }
    }

    // Refresh BFS-dependent data when BFS selection changes
    refreshCompletedTabData() {
        // Load all tab data to ensure counts are updated
        this.loadAllTabData();
    }

    // Handle BFS selection change - ensures proper sequencing of operations
    onBFSChange() {
        // Clear existing data to avoid showing stale information
        this.clearExistingData();
        // Set currency symbol based on new BFS
        this.setCurrencySymbol();
        // First get available ledger balance
        this.getAvailableLedgerBalance();
        // Then refresh all tab data
        this.refreshCompletedTabData();
    }

    // Clear existing data when BFS changes to avoid showing stale information
    clearExistingData() {
        // Clear pending data
        this.allOrderShipments = [];
        this.orderShipments = [];
        this.total = 0;
        
        // Clear completed data
        this.allPackedShipments = [];
        this.allPackedChildShipments = [];
        
        // Clear on hold data
        this.shipmentsOnHoldList = [];
        
        // Reset counts
        this.regularCount = 0;
        this.emergencyCount = 0;
        this.orderPackedRegularCount = 0;
        this.orderPackedEmergencyCount = 0;
        this.regularShipmentsOnHoldCount = 0;
        this.emergencyShipmentsOnHoldCount = 0;
        
        // Clear denominations
        this.denominations = {};
        this.denominationsArray = [];
        this.totalDenomAmount = 0;
        this.model.searchText = "";
        this.model.route = null;
        this.model.pendingFilterDate = null;
      }

    goToBulkCash() {
        this.$state.go('bulkCashManagement');
    }

    getPendingPackShipmentsOnHold() {
        if (!this.model.locationId) {
            this.shipmentsOnHoldList = [];
            this.loadOrderPackingList();
            return;
        }
        
        const date = moment(this.model.date).format('YYYY-MM-DD');
        this.loadOnHoldShipments = true;

        return this.OrderPackingService.getPendingPackShipmentsOnHold(this.model.branchId, date)
            .then((data) => {
                this.shipmentsOnHoldList = data.results;
                this.loadOrderPackingList();
                this.filterOnHoldShipments(this.shipmentsOnHoldList);
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.loadOnHoldShipments = false;
            })
    }

    filterOnHoldShipments(data) {
        // Deduplicate COD multi-denom rows: group by unique shipment key
        // For COD rows we have packableOrderShipmentId; otherwise fallback to trackingId
        const grouped = _.groupBy(data, (s) => s.packableOrderShipmentId ? `${s.orderNo}_${s.packableOrderShipmentId}` : s.trackingId);
        const uniqueShipments = Object.keys(grouped).map(k => grouped[k][0]);

        this.regularShipmentsOnHoldCount = 0;
        this.emergencyShipmentsOnHoldCount = 0;
        uniqueShipments.forEach((item) => {
            this.emergencyShipmentsOnHoldCount += item.isEC;
            this.regularShipmentsOnHoldCount += !item.isEC;
        })
    }

    goToItemHistory(trackingId) {
        this.Navigation.goToItemHistory(trackingId, null);
    }

    releaseItem(shipment) {
        if (this.isLoading) return;
        this.isLoading = true;

        this.UsersService.checkSupervisor(this.model.loggedInUser)
            .then((userInfo) => {
                this.Modal.holdReleases(shipment, !userInfo.supervisor, ({ supervisorId, comment, shipmentAssignedTo, selectedDate, routeInfo, modal }) => {
                    var hDate = moment(selectedDate).format('YYYY-MM-DD');
                    this.ShipmentService.holdRelease(shipment.trackingId, shipment.routeId, shipmentAssignedTo, hDate, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId)
                        .then(() => {
                            modal.close();
                            this.Sound.playSuccessBeep("#success_beep");
                        })
                        .then(() => {
                            if (routeInfo.routeTransfered) {
                                this.updateRouteDetail(shipmentAssignedTo, selectedDate);
                            }
                            if (routeInfo.autoOptimize) {
                                this.autoOptimizeRouteStop(shipmentAssignedTo, selectedDate);
                            }
                        })
                        .then(() => {
                            // Refresh all tab data after successful release operation
                            this.loadAllTabData();
                            this.isLoading = false;
                        })
                        .catch((err) => {
                            modal.close();
                            this.isLoading = false;
                            this.Sound.PlayErrorBeep("#scanner_beep");
                            if (err && err.data && err.data.message) {
                                return this.Modal.errorModal("error." + err.data.message);
                            }
                        })
                }, ({ modal }) => {
                    this.isLoading = false;
                    if (modal) modal.close();
                })
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    autoOptimizeRouteStop(routeId, routeDate) {
        var formattedDate = moment.utc(routeDate).format('YYYY-MM-DD');
        this.RouteStopService.autoOptimizeRouteStops(formattedDate, routeId)
            .then(() => void undefined)
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
    }

    updateRouteDetail(route, date) {
        var formattedDate = moment.utc(date).format('YYYY-MM-DD');
        this.HoldService.updateRouteDetail(route)
            .then(() => {
                return this.RouteService.releaseRoute(route, formattedDate);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    isAllowedToUnpack(shipment) {
        let shipmentPackedDate, branchCurrentVaultDate;

        if (shipment.fundingSourceId && shipment.unpackAnyTime) {
            return true;
        }
        else if (shipment.fundingSourceId && !shipment.unpackAnyTime) {
            shipmentPackedDate = new Date(shipment.packedDate);
            branchCurrentVaultDate = new Date(this.branchVaultDate);
            return shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
        }
        else {
            return true;
        }
    }

    getFundingSource(data) {
        const grouped = _.groupBy(data, 'fundingSourceId');
        const list = [];

        const keys = Object.keys(grouped);
        keys.map((key) => {
            let location = key.concat(" | ", grouped[key][0].sourceName);
            list.push({ Key: location, Value: key })
        })
        this.fundingSourceList = list;
    }

    getCustomerList(data) {
        const withCustomer = (data || []).filter((item) => item.customerId);
        const grouped = _.groupBy(withCustomer, 'customerId');
        const keys = Object.keys(grouped);
        this.customerList = keys.map((key) => {
            const sample = grouped[key][0];
            return {
                label: sample.customerName ? `${key} | ${sample.customerName}` : key,
                value: key
            };
        });
    }

    exportPackedShipment() {
        const date = moment(this.model.date).format('YYYY-MM-DD');
        const bfsId = this.model.locationId ? this.model.locationId.Value : null;

        this.exportCompletedView = true;
        return this.OrderPackingService.exportPackedShipments(this.model.branchId, date, this.sortColumn, !this.reverseSort, this.model.orderType, this.model.route, this.model.searchText, bfsId, this.currencySymbol, this.model.customerId)
            .then(() => {
                this.exportCompletedView = false
            })
            .catch((err) => {
                this.exportCompletedView = false
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
    }

    exportPendingPackShipments() {
        const date = moment(this.model.date).format('YYYY-MM-DD');

        this.exportPendingPackView = true;
        const pendingFilterDate = this.model.pendingFilterDate ? moment.parseZone(this.model.pendingFilterDate).format('YYYY-MM-DD'): null;
        return this.OrderPackingService.exportPendingPackShipmentsAndOrders(this.model.locationId.locId, this.model.locationId.Key, this.model.branchId, this.model.orderType, this.model.route, this.model.searchText, date, this.currencySymbol, pendingFilterDate, this.model.customerId)
            .then(() => {})
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.exportPendingPackView = false;
            })
    }

    toggleAllShipmentSelection() {
        this.completedShipmentDetails = [];
        this.packedShipments.forEach((shipment) => {
            shipment.isSelected = this.toggleSelect;
        });
        this.toggleSelect = !this.toggleSelect;
    }

    printPackedShipmentLabel() {
        this.completedShipmentDetails = [];
        let packedShipments = this.sort([...this.packedShipments], this.sortColumn, this.reverseSort);

        packedShipments.forEach((shipment) => {
            if (shipment.isSelected) {
                if (this.model.locationId && this.model.locationId.multiDenomPack) {
                    const firstItem = (shipment.shipments && shipment.shipments[0]) || shipment;
                    let trackingId = firstItem.loadTrackingId || shipment.loadTrackingId || shipment.bagSeal || shipment.trackingId;
                    if (trackingId) {
                        trackingId = trackingId.split('-')[0];
                    }

                    let totalDenomAmount = 0;
                    const denominations = (shipment.denominations || []).map(denom => {
                        totalDenomAmount += (denom.amount || 0);
                        return {
                            id: denom.id || denom.denominationId,
                            amount: denom.amount,
                            symbol: denom.symbol || this.currencySymbol
                        };
                    });

                    this.completedShipmentDetails.push({
                        trackingId: trackingId,
                        isLoadTrackingId: true,
                        locationInfo: {
                            id: shipment.toLocationId || null,
                            name: shipment.toLocation ? shipment.toLocation.name : null,
                            address: shipment.toLocation ? shipment.toLocation.address : null,
                            city: shipment.toLocation ? shipment.toLocation.city : null,
                            state: shipment.toLocation ? shipment.toLocation.state : null,
                            zip: shipment.toLocation ? shipment.toLocation.zip : null
                        },
                        orderNo: shipment.orderNo,
                        orderType: this.getOrderType(shipment),
                        routeId: shipment.routeId,
                        deliveryDate: shipment.deliveryDate,
                        amount: totalDenomAmount,
                        vaultDate: moment.utc(shipment.vaultDate).format('MM-DD-YY'),
                        defRouteSequence: shipment.defRouteSequence,
                        fundingSource: this.model.locationId ? this.model.locationId.sourceName : null,
                        denominations: denominations,
                        totalDenomAmount: totalDenomAmount,
                        symbol: shipment.symbol || this.currencySymbol
                    });
                } else {
                (shipment.shipments || [shipment]).forEach((item) => {
                    const isR = !item.trackingId && shipment.residualTrackingId;
                    this.completedShipmentDetails.push({
                        trackingId: item.loadTrackingId || item.trackingId || (isR ? shipment.residualTrackingId : `${shipment.orderNo}-${item.denominationId}`),
                        isLoadTrackingId: !isR,
                        locationInfo: {
                            id: isR ? (shipment.fromLocationId ? shipment.fromLocation.id : null) : (shipment.toLocationId ? shipment.toLocationId : null),
                            name: isR ? (shipment.fromLocationId ? shipment.fromLocation.name : null) : (shipment.toLocationId ? shipment.toLocation.name : null),
                            address: isR ? (shipment.fromLocationId ? shipment.fromLocation.address : null) : (shipment.toLocationId ? shipment.toLocation.address : null),
                            city: isR ? (shipment.fromLocationId ? shipment.fromLocation.city : null) : (shipment.toLocationId ? shipment.toLocation.city : null),
                            state: isR ? (shipment.fromLocationId ? shipment.fromLocation.state : null) : (shipment.toLocationId ? shipment.toLocation.state : null),
                            zip: isR ? (shipment.fromLocationId ? shipment.fromLocation.zip : null) : (shipment.toLocationId ? shipment.toLocation.zip : null)
                        },
                        orderNo: shipment.orderNo,
                        orderType: this.getOrderType(shipment),
                        routeId: shipment.routeId,
                        deliveryDate: shipment.deliveryDate,
                        pickupDate: isR ? shipment.pickupDate : null,
                        amount: item.amount,
                        denominationId: item.denominationId,
                        vaultDate: moment.utc(shipment.vaultDate).format('MM-DD-YY'),
                        defRouteSequence: shipment.defRouteSequence,
                        fundingSource: this.model.locationId ? this.model.locationId.sourceName : null
                    });
                });
                }
            }
        });

        const obj = {
            shipmentDetails: this.completedShipmentDetails,
            isPrePackPrint: false,
            multiDenomPack: this.model.locationId ? this.model.locationId.multiDenomPack : false,
            currencySymbol: this.currencySymbol
        }

        const path = this.$state.href('printBarcodes');
        window.w = window.open(path, '_blank');
        window.w.printData = obj;
    }

    validateBarcodeBtn() {
        var disableButton = this.packedShipments.map((ps) => {
            return !ps.isSelected || 'isEmpty'
        })
            .indexOf('isEmpty') !== -1;

        return disableButton;
    }

    getOrderTypeList(data) {
        this.orderTypeList = [];
        // Prefer orderType when present; fall back to shiptypeId only when orderType is missing
        const normalized = data.map(d => ({
            orderType: d.orderType || null,
            shiptypeId: d.shiptypeId || null
        }));

        const orderTypes = normalized.filter(x => x.orderType || x.shiptypeId);
        const grouped = _.groupBy(orderTypes, (x) => x.orderType || x.shiptypeId);
        const keys = Object.keys(grouped);
        keys.forEach((key) => {
            const sample = grouped[key][0];
            const hasOrderType = !!sample.orderType;
            let label = key;
            
            if (hasOrderType) {
                // Try translation, fall back to raw value if translation doesn't exist
                const translationKey = "shipment.order_type_" + key;
                const translated = this.$translate.instant(translationKey);
                label = translated !== translationKey ? translated : key;
            }
            
            this.orderTypeList.push({
                label: label,
                value: key,
            });
        });
    }

    printBarcodes = () => {
        this.pendingPackShipmentDetails = [];
        let orderShipments = this.sort(this.orderShipments, this.sortColumn, this.reverseSort);

        orderShipments.map((shipmentItem) => {
            if (shipmentItem.isSelected) {
                let totalDenomAmount = 0;
                if (this.model.locationId.multiDenomPack && shipmentItem.denominations) {
                    shipmentItem.denominations.forEach(d => totalDenomAmount += (d.amount || 0));
                }

                this.pendingPackShipmentDetails.push({
                    trackingId: shipmentItem.trackingIdDelivery,
                    toLocationId: shipmentItem.toLocationId,
                    locationInfo: {
                        id: shipmentItem.toLocationId ? shipmentItem.toLocationId : null,
                        name: shipmentItem.toLocationId ? shipmentItem.toLocation.name : null,
                        address: shipmentItem.toLocationId ? shipmentItem.toLocation.address : null,
                        city: shipmentItem.toLocationId ? shipmentItem.toLocation.city : null,
                        state: shipmentItem.toLocationId ? shipmentItem.toLocation.state : null,
                        zip: shipmentItem.toLocationId ? shipmentItem.toLocation.zip : null,
                    },
                    orderNo: shipmentItem.orderNo,
                    orderType: shipmentItem.orderType,
                    routeId: shipmentItem.routeId,
                    deliveryDate: shipmentItem.deliveryDate,
                    amount: shipmentItem.amount,
                    denominationId: !this.model.locationId.multiDenomPack ? shipmentItem.denominationId : null,
                    vaultDate: moment.utc(shipmentItem.vaultDate).format('YYYY-MM-DD'),
                    defRouteSequence: shipmentItem.defRouteSequence,
                    denominations: this.model.locationId.multiDenomPack ? shipmentItem.denominations : [],
                    shiptypeId: shipmentItem.shiptypeId,
                    symbol: shipmentItem.symbol || this.currencySymbol,
                    fundingSource: this.model.locationId ? this.model.locationId.sourceName : null,
                    totalDenomAmount: totalDenomAmount
                })
            }
        })

        const obj = {
            shipmentDetails: this.pendingPackShipmentDetails,
            isPrePackPrint: true,
            multiDenomPack: this.model.locationId.multiDenomPack,
            currencySymbol: this.currencySymbol
        };

        const path = this.$state.href('printBarcodes');
        window.w = window.open(path, '_blank');
        window.w.printData = obj;
    }

    toggleAllPrePackShipments() {
        this.pendingPackShipmentDetails = [];
        this.orderShipments.forEach((shipment) => {
            shipment.isSelected = this.toggleSelect;
        });
        this.orderShipments.forEach((order) => {
            order.isSelected = this.toggleSelect
        })
        this.toggleSelect = !this.toggleSelect;
    }

    validatePrePackPrintBtn() {
        var disableButton = this.orderShipments.map((ps) => {
            return !ps.isSelected || 'isEmpty'
        })
            .indexOf('isEmpty') !== -1;

        return disableButton;
    }

    resetFilterData(){
        this.routeObj = this.DataCounter.setData();
    }

    printPackedOrders() {
        const date = moment(this.model.date).format('YYYY-MM-DD');
        const bfsId = this.model.locationId ? this.model.locationId.Value : null;
        const obj = {
            branchId: this.model.branchId,
            vaultDate: date,
            sortColumn: this.sortColumn,
            reverseSort: this.reverseSort,
            orderType: this.model.orderType,
            route: this.model.route,
            searchText: this.model.searchText,
            fundingSourceId: bfsId,
            currencySymbol: this.currencySymbol,
            customerId: this.model.customerId
        }
        const path = this.$state.href('printPackedOrders');
        window.w = window.open(path, '_blank');
        window.w.printData = obj;
    }
    
    goToCurrencyPick() {
        const dateToPass = this.model.pendingFilterDate || this.model.date;
        const obj = {
            fundingSourceId: this.model.locationId ? this.model.locationId.Value : null,
            date: moment(dateToPass).format('YYYY-MM-DD')
        };
        this.DataCounter.setData(obj);
        this.$state.go('orderPacking.currencyPickReport');
    }
}
export default OrderPackingController;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/order_packing.controller.js